import { GroupedNotification } from "@/pages/rollshop/models/RollshopNotification";
import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { DoneAll, RemoveDone } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { ActionTypeTag } from "../components/utils/ActionTypeTag";
import { SourceCodeTag } from "../components/utils/SourceCodeTag";

type Props = {
	onAcknowledge: (alertId: number) => void;
	onUnacknowledge: (alertId: number) => void;
};

export const useTableData = ({ onAcknowledge, onUnacknowledge }: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "CreatedAt",
			headerName: "Date",
			flex: 1,
			valueFormatter: (params) => {
				return dxtToLocalServerTime(params.value, "MM/dd/yy HH:mm") || "";
			},
		},
		{
			field: "ActionTypeCode",
			headerName: "Type",
			flex: 0.8,
			cellRenderer: (params: ICellRendererParams) => {
				const alert = params.data as GroupedNotification;
				return <ActionTypeTag code={alert?.ActionTypeCode} showName />;
			},
		},
		{
			field: "SourceCode",
			headerName: "Source",
			flex: 1,
			cellRenderer: (params: ICellRendererParams) => {
				const alert = params.data as GroupedNotification;
				if (alert?.SourceCode) {
					return <SourceCodeTag code={alert.SourceCode} />;
				}
				return null;
			},
		},
		{
			field: "Description",
			headerName: "Description",
			flex: 3,
			autoHeight: true,
			wrapText: true,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-start",
				whiteSpace: "normal",
			},
		},
		{
			field: "CreatedBy",
			headerName: "Created By",
			minWidth: 100,
			flex: 0.8,
		},
		{
			field: "Actions",
			headerName: "",
			minWidth: 60,
			maxWidth: 60,
			cellRenderer: (params: ICellRendererParams) => {
				const alert = params.data as GroupedNotification;
				if (!alert) return null;

				const isPending = alert?.StatusCode === "P";
				const isAcknowledged = alert?.StatusCode === "A";

				return (
					<Tooltip
						title={
							isPending
								? "Mark as Acknowledged"
								: isAcknowledged
									? "Mark as Unacknowledged"
									: ""
						}
					>
						<IconButton
							size="small"
							onClick={(e) => {
								e.stopPropagation();
								isPending
									? onAcknowledge(alert.NotificationId)
									: isAcknowledged
										? onUnacknowledge(alert.NotificationId)
										: null;
							}}
						>
							{isPending ? (
								<DoneAll fontSize="small" />
							) : isAcknowledged ? (
								<RemoveDone fontSize="small" />
							) : null}
						</IconButton>
					</Tooltip>
				);
			},
		},
	];

	return { columnDefs };
};
